export default __webpack_public_path__ + "static/media/white_king.2a9b2be4.png";